<template>
    <div class="shipManage">
        <navs></navs>
         <div class="shipManage">
            <p class="bigTitle">船舶管理</p>
            <p class="smallTitle">SHIP MANAGEMANT</p>
        </div>

          <!--数据采集-->
        <div class="shipManIntro">
           <div class="titles">专业管理团队</div>
           <p class="collectSub">
               15年+专业船舶管理经验，拥有科学、严谨、建全的管理体系
            </p>
            <div class="collectImg"></div>
        </div>
        <div class="shipManIntro">
           <div class="titles">航行决策分析</div>
           <p class="collectSub">
              帮助对船舶航行线路进行分析，包括：吃水限制、桥梁限高、潮汐变化、成本测算等
            </p>
            <div class="collectImg1"></div>
        </div>
        <div class="shipManIntro">
           <div class="titles">全天候故障技术支持</div>
           <p class="collectSub">
            7*24小时全天候待命，对船舶异常报警、设备故障等问题提供免费技术支持
            </p>
            <div class="collectImg2"></div>
        </div>
         <div class="shipManIntro" style='border:none'>
           <div class="titles">风险预警</div>
           <p class="collectSub">
               风险预警通过航运大数据系统，全天候智能监测预警（风浪、潮汐、碰撞等），为船舶安全航行保驾护航
           </p>
            <div class="collectImg3"></div>
        </div>

        <foot></foot>
      <rightC></rightC>
    </div>
</template>
<script>
import navs from '@/components/nav/head';
import foot from '@/components/nav/footer';
import rightC from '@/components/nav/rightFloat'
export default {
    name:'shipManage',
    data(){
        return{
          current: 0
        }
    },
    components:{
     navs,foot,rightC
    },
    created(){

    }
}
</script>
<style lang='less' rel='stylesheet/less' >
   @rem:16rem;
   @col-f:#fff;
   .shipManage{
       width: 100%;
       height: 160/@rem;
       background: url('../assets/chuan-b.png');
       background-repeat: no-repeat;
       background-position: center center;
       background-size: ceil(100%) ceil(100%);
       align-items: center;
       .bigTitle{
           text-align: center;
           color: @col-f;
           font-size: 22/@rem;
           padding-top: 48/@rem;
           margin: 0;
           font-weight: 400;
       }
       .smallTitle{
           text-align: center;
           color: @col-f;
           font-size: 10/@rem;
           padding-top:10/@rem;
            margin: 0;
           font-weight: 300;

       }
   }



  .shipManIntro{
       padding: 22/@rem 0;
       margin: 0 16/@rem;
       border-bottom: 1px solid #E3E9EF;
    .titles{
       font-size: 16/@rem;
       text-align: center;
       color:  #333;
       font-weight: bold;
  }
      .collectSub{
          font-size: 10/@rem;
          color: #666;
        //   text-align:justify;
        //   text-align-last: center;
        text-align: center;
      }

      .collectImg{

            width: 100%;
            height: 244/@rem;
            background: url('../assets/chuan1.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 188/@rem 164/@rem;
      }
       .collectImg1{

            width: 100%;
            height: 264/@rem;
            background: url('../assets/chuan2.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 148/@rem 224/@rem;
      }
       .collectImg2{

            width: 100%;
            height: 244/@rem;
            background: url('../assets/chuan3.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 188/@rem 164/@rem;
      }
       .collectImg3{

            width: 100%;
            height: 244/@rem;
            background: url('../assets/chuan4.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 188/@rem 164/@rem;
      }

  }
  .swipeBox{
      height: 13.2rem;
  }
 .hangBox{
       width: 100%;
       height: 310/@rem;
       background-image: url('../assets/hang-bg.png');
       background-repeat: no-repeat;
       background-position: center center;
       background-size: ceil(100%) ceil(100%);


   .beiName{
       font-weight: bold;
       font-size: 14/@rem;
       text-align: center;
       color: #333;
       padding-top: 26/@rem;
       padding-bottom: 14/@rem
   }
   .beiInner{
       width: 131/@rem;
       height: 170/@rem;
       background: #fff;
       margin-left: 20/@rem;
       text-align: center;

       .beiImg{
           width: 28/@rem;
           padding-top: 12/@rem;
       }
        .beiImg1{
           width: 18/@rem;
           padding-top: 12/@rem;
       }
       .beiImg2{
           width: 26/@rem;
           padding-top: 12/@rem;
       }
         .beiImg3{
           width: 26/@rem;
           padding-top: 12/@rem;
       }
       .beiLine{
           height: 0.2rem;
           background-image: url('../assets/hang-line.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 1.4rem 0.2rem;
            margin-bottom: 0.4rem;
       }
       .beiTitle{
          font-size:10/@rem;
          font-weight: 800;
          color: #333;
          margin: 0
       }
       .beiIntro{
          font-size:9/@rem;
          color: #666;
          margin: 0 ;
          padding: 10/@rem 14/@rem;
         text-align: left;
          line-height: 16/@rem
       }
     }
   }
</style>



// WEBPACK FOOTER //
// src/components/shipManage.vue